import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckBoxOptions, ControlLayout, FilterItem, FilterType, InputType, MultiLingualTextBoxOptions, PagingOptions, TextAreaOptions, TextBoxOptions } from 'bnsights-control-library';
import { ClipboardService } from 'ngx-clipboard';
import { LookUpItem } from '../../shared/models/Lookups/LookupItem';
import { LookupService } from '../../shared/Services/LookupService.service';
import { EnglishArabicDTO } from 'bnsights-control-library';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-lookup-item',
  templateUrl: './lookup-item.component.html'
})
export class LookupItemComponent implements OnInit {
  SubheaderTitle = "";
  ShowToolbar = true;
  ShowbreadCrumb = true;
  BreadcrumbTitle: string=this.utilityService.getResourceValue('Lookups');
  Url="/Admin/Lookups/Lookups"
  ApiUrl = "/api/admin/Lookup/"
  LookupId:string;
  searchTextBox: TextBoxOptions;
  LookupIdTextBox: TextBoxOptions;
  LookupItemForm = new FormGroup({});
  showFilter: boolean = false;
  LookupItemPagingResult: any[] = [];
  LookupItemPaging: PagingOptions;
  TextInputFilter: FilterItem;
  LookupIdInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean = false;
  LookupName:EnglishArabicDTO=new EnglishArabicDTO();
  @ViewChild('LookupItemPagingViewElement', { static: false }) input: ElementRef;

  //Add Model Controls
  AddLookupItemForm = new FormGroup({});
  MultiLingualName:MultiLingualTextBoxOptions
  SysName: TextBoxOptions;
  Value: TextAreaOptions;
  DisplayOrder: TextAreaOptions;
  IsManageable: CheckBoxOptions;
  @ViewChild('CloseLookupItemModal', { static: false }) CloseLookupItemModal: ElementRef;
  
  //Edit Model Controls
  EditLookupItemForm = new FormGroup({});
  LookupItemId:number
  EditMultiLingualName:MultiLingualTextBoxOptions
  EditSysName: TextBoxOptions;
  EditValue: TextAreaOptions;
  EditDisplayOrder: TextAreaOptions;
  EditIsManageable: CheckBoxOptions;
  @ViewChild('CloseEditLookupItemModal', { static: false }) CloseEditLookupItemModal: ElementRef;

  //delete  Model Controls
  deletedLookupItemId: number = 0
  @ViewChild('CloseDeleteLookupItemModal', { static: false }) CloseDeleteLookupItemModal: ElementRef;

  //GenerateCode  Model Controls 
  GenerateCodeForm = new FormGroup({});
  GenerateCodeTextArea: TextAreaOptions;
  ValueToCopy: string = "";
  language:string="";
  IsParentLookupManageable:boolean=false;
  // Decorator wires up blockUI instance
  ShowPageContent: boolean = false;

  constructor( private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private _clipboardService: ClipboardService, private LookupService: LookupService, private activatedRoute: ActivatedRoute, private router: Router, private modalService: NgbModal) {
    this.activatedRoute.params.subscribe(params => {
      this.LookupId = params['id'];
      this.LookupName.English = params['nameen'];
      this.LookupName.Arabic = params['namear'];
    });
  }
  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadDropdownLists();
  }

 
  ReinitializeTemplatePaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }
  UpdateTemplatePaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setLookupItemListResult(result) {
    this.LookupItemPagingResult = result
    this.SubheaderTitle = this.language == "en" ? this.LookupName.English : this.LookupName.Arabic;
    this.ShowPageContent = true;
    PageInfoService.PageTitle=this.SubheaderTitle 
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false},
       {title: this.utilityService.getResourceValue("Lookups") , path: '/Admin/Lookups/Lookups', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}
  
    ]; 

    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.utilityService.stopBlockUI();
  }
  resetFilters() {
    this.LookupItemForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();

  }
  LoadDropdownLists() {
    // TextBox inti
    this.searchTextBox = new TextBoxOptions();
    this.searchTextBox.Name = "searchTextBox"
    this.searchTextBox.HideLabel = true
    this.searchTextBox.Type = InputType.Text
    this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")


    this.TextInputFilter = new FilterItem();
    this.TextInputFilter.FormControlName = "searchTextBox"
    this.TextInputFilter.ActionParameterName = "searchText"
    this.TextInputFilter.IsFormControl = true
    this.TextInputFilter.FilterType = FilterType.TextBox

    // TextBox inti
    this.LookupIdTextBox = new TextBoxOptions();
    this.LookupIdTextBox.Name = "LookupIdTextBox"
    this.LookupIdTextBox.HideLabel = true
    this.LookupIdTextBox.Type = InputType.Text
    this.LookupIdTextBox.Value = Number(this.LookupId);


    this.LookupIdInputFilter = new FilterItem();
    this.LookupIdInputFilter.FormControlName = "LookupIdTextBox"
    this.LookupIdInputFilter.ActionParameterName = "LookupId"
    this.LookupIdInputFilter.IsFormControl = true
    this.LookupIdInputFilter.FilterType = FilterType.TextBox


    this.LookupItemPaging = new PagingOptions();
    this.LookupItemPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetLookupItemsByFilter';
    this.LookupItemPaging.OnKeyPressFiltersControlNames = ["searchTextBox","LookupIdTextBox"]
    this.LookupItemPaging.Filters = [this.LookupIdInputFilter, this.TextInputFilter]
    this.LookupItemPaging.ValidationToken = this.authService.authorizationHeaderValue()
    setTimeout(() => {
      this.IsFilterLoaded = true;
    }, 10);

   
  }

  
  showAddLookupItemModal(AddLookupItemModal) {
    this.utilityService.startBlockUI();
    this.AddLookupItemForm = new FormGroup({});

    
    this.MultiLingualName = new MultiLingualTextBoxOptions();
    this.MultiLingualName.Name = "Name";
    this.MultiLingualName.ArabicLabelKey = "NameInArabic";
    this.MultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.MultiLingualName.IsRequired = true;
    this.MultiLingualName.Value = null;

    this.SysName = new TextBoxOptions();
    this.SysName.Name = "SysName";
    this.SysName.LabelKey = "SysName";
    this.SysName.Type = InputType.Text;
    this.SysName.Value = null;

    this.Value = new TextAreaOptions();
    this.Value.Name = "Value";
    this.Value.LabelKey = "Value";
    this.Value.Value = null;

    this.DisplayOrder = new TextAreaOptions();
    this.DisplayOrder.Name = "DisplayOrder";
    this.DisplayOrder.LabelKey = "DisplayOrder";
    this.DisplayOrder.Value = null;


    this.IsManageable = new CheckBoxOptions();
    this.IsManageable.Name = "IsManageable"
    this.IsManageable.LabelKey = "Manageable"

    this.modalService.open(AddLookupItemModal);
    this.utilityService.stopBlockUI();
  }

  addLookupItem() {
    if (this.AddLookupItemForm.invalid) {
      return;
    }
    else {
      
      let ResultModel = this.AddLookupItemForm.value;
      let addModel = new LookUpItem();
      addModel.Name.English = ResultModel.Name.EnglishValue
      addModel.Name.Arabic = ResultModel.Name.ArabicValue
      addModel.SysName = ResultModel.SysName
      addModel.Value = ResultModel.Value
      addModel.DisplayOrder = ResultModel.DisplayOrder
      addModel.LookupID =Number(this.LookupId)
      addModel.Manageable = this.ProductionMode==true?true:false;
       this.LookupService.AddLookupItem( addModel).subscribe((result) => {
         this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
      
      })
    }
  }

  showEditLookupItemModal(LookupItem: any, EditLookupItemModal) {
    this.utilityService.startBlockUI();
    this.EditLookupItemForm = new FormGroup({});

    this.LookupItemId = LookupItem.id


    let Name=new EnglishArabicDTO();
    Name.Arabic=LookupItem.name.arabic;
    Name.English=LookupItem.name.english;

    this.EditMultiLingualName = new MultiLingualTextBoxOptions();
    this.EditMultiLingualName.Name = "Name";
    this.EditMultiLingualName.ArabicLabelKey = "NameInArabic";
    this.EditMultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.EditMultiLingualName.IsRequired = true;
    this.EditMultiLingualName.Value = Name;

    this.EditSysName = new TextBoxOptions();
    this.EditSysName.Name = "EditSysName";
    this.EditSysName.LabelKey = "SysName";
    this.EditSysName.Type = InputType.Text;
    this.EditSysName.Value = LookupItem.sysName;


    this.EditValue = new TextAreaOptions();
    this.EditValue.Name = "EditValue";
    this.EditValue.LabelKey = "Value";
    this.EditValue.Value = LookupItem.value;


    this.EditDisplayOrder = new TextAreaOptions();
    this.EditDisplayOrder.Name = "EditDisplayOrder";
    this.EditDisplayOrder.LabelKey = "DisplayOrder";
    this.EditDisplayOrder.Value = LookupItem.displayOrder;


    this.EditIsManageable = new CheckBoxOptions();
    this.EditIsManageable.Name = "EditIsManageable"
    this.EditIsManageable.LabelKey = "Manageable"
    this.EditIsManageable.Value = LookupItem.manageable
    this.EditIsManageable.IsDisabled= (this.ProductionMode&&LookupItem.manageable==false)==true?true:false;

    this.modalService.open(EditLookupItemModal);
    this.utilityService.stopBlockUI();

  }
  editLookupItem() {
    if (this.EditLookupItemForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditLookupItemForm.value;
      let EditModel = new LookUpItem();
      EditModel.ID = Number(this.LookupItemId);
      EditModel.LookupID = Number(this.LookupId);
      EditModel.Name.English = ResultModel.Name.EnglishValue
      EditModel.Name.Arabic = ResultModel.Name.ArabicValue
      EditModel.SysName = ResultModel.EditSysName
      EditModel.Value = ResultModel.EditValue
      EditModel.DisplayOrder = ResultModel.EditDisplayOrder
      EditModel.Manageable = ResultModel.EditIsManageable
    
      this.LookupService.EditLookupItem( EditModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
      
      })
    }
  }
  showDeleteLookupItemModal(lookupItem: any, DeleteLookupItemModal) {
    this.utilityService.startBlockUI();
    this.deletedLookupItemId = lookupItem.id
    this.modalService.open(DeleteLookupItemModal);
    this.utilityService.stopBlockUI();
  }
  DeleteLookupItem() {
    this.LookupService.DeleteLookupItem(this.deletedLookupItemId).subscribe((result) => {
      this.deletedLookupItemId = 0;
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
    
    })

  }

  copyInputMessage() {
    this._clipboardService.copy(this.ValueToCopy.toString());
  }
  showGenerateCodeByIdModal(GenerateCodeModal) {
    this.LookupService.GenerateCodeById(Number(this.LookupId)).subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy = Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.GenerateCodeTextArea.ViewType = ControlLayout.Horizontal;
      this.modalService.open(GenerateCodeModal);
    }, (error) => {
     
    })
  }
}
